// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__3wTwN","Div":"CustomFadeBox_Div__3gItt","LargeDiv":"CustomFadeBox_LargeDiv__2FjcB"};